<template>
  <div class="totalTrees">
    {{reserve}}
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'InfoWindow',
  components: { 
    
  },
  props: [ 'reserve' ],
  data () {
    return {
      reserveData: null
    }
  },
  computed:{
    storeItems() {
      this.reserveData = this.$store.state.reserves.items
      console.log('Datos:' + reserveData)
    }
  },
  methods: {
    
  }
}
</script>

<style lang="scss">
@import '@/style/_variables.scss';

</style>



// WEBPACK FOOTER //
// src/components/InfoWindow.vue